import { MapPlaceSuggestion } from 'types';

interface ActionTypes {
  SET_EMERGENCY_CONTACTS_GEO_JSON: string;
  EMERGENCY_CONTACTS_START: string;
  EMERGENCY_CONTACTS_SUCCESS: string;
  EMERGENCY_CONTACTS_FAILURE: string;

  GET_EC_GEOCODE_START: string;
  GET_EC_GEOCODE_SUCCESS: string;
  GET_EC_GEOCODE_FAILURE: string;
  CLEAR_EC_GEOCODE: string;
  CLEAR_EC_DATA: string;
}

const ECActionTypes: ActionTypes = {
  SET_EMERGENCY_CONTACTS_GEO_JSON: '@@SET_EMERGENCY_CONTACTS_GEO_JSON',
  EMERGENCY_CONTACTS_START: '@@EMERGENCY_CONTACTS_START',
  EMERGENCY_CONTACTS_SUCCESS: '@@EMERGENCY_CONTACTS_SUCCESS',
  EMERGENCY_CONTACTS_FAILURE: '@@EMERGENCY_CONTACTS_FAILURE',
  GET_EC_GEOCODE_START: '@@GET_EC_GEOCODE_START',
  GET_EC_GEOCODE_SUCCESS: '@@GET_EC_GEOCODE_SUCCESS',
  GET_EC_GEOCODE_FAILURE: '@@GET_EC_GEOCODE_FAILURE',
  CLEAR_EC_GEOCODE: '@@CLEAR_EC_GEOCODE',
  CLEAR_EC_DATA: '@@CLEAR_EC_DATA'
};

export interface EmergencyContactsState {
  GeoJSONPoints?: string;
  ecLoading: boolean;
  error?: string;
  contacts?: any;
  suggestion?: MapPlaceSuggestion[];
  geocode?: any;
}

export default ECActionTypes;
